import { useState, useEffect, useCallback } from "react";
import type { TIngredient } from "./../store/types";
import { _t } from "core/language";
// import { useSelector } from "react-redux";

const useSelectIngredient = (
  ingredientList: TIngredient[],
  initIngredients?: TIngredient[]
) => {
  // const {ingredients} = useSelector((state: any) => state.Ingredients.recipes);
  const [ingredientSelecting, setIngredientSelecting] = useState<TIngredient[]>(
    initIngredients || []
  )
  const [isSelectAll, setIsSelectAll] = useState<boolean>(false)

  useEffect(() => {
    if (initIngredients?.length) {
      setIngredientSelecting(initIngredients)
    }
  }, [initIngredients])

  useEffect(() => {
    if (ingredientList?.length) {
      setIngredientSelecting((p: TIngredient[]) => 
        p.filter((e: TIngredient) => 
          ingredientList.map((e: TIngredient) => e.id).includes(e.id)
        )
      )
    }
  }, [ingredientList])

  useEffect(() => {
    if (ingredientList.length) {
      setIsSelectAll(ingredientList.length === ingredientSelecting.length)
    }
  }, [ingredientList, ingredientSelecting])

  const checkIngredientSelected = useCallback((item: TIngredient) => {
    return ingredientSelecting.map((e: TIngredient) => e.id).includes(item.id)
  }, [ingredientSelecting])

  const selectIngredient = useCallback((item: TIngredient) => {
    const check = checkIngredientSelected(item)
    if (check) {
      setIngredientSelecting((p: TIngredient[]) => 
        p.filter((e: TIngredient) => e.id !== item.id)
      )
    } else {
      setIngredientSelecting((p: TIngredient[]) => ([...p, item]))
    }
  }, [checkIngredientSelected, setIngredientSelecting])

  const selectAllIngredient = useCallback(() => {
    if (isSelectAll) {
      setIngredientSelecting([])
    } else {
      setIngredientSelecting(ingredientList)
    }
  }, [setIngredientSelecting, ingredientList, isSelectAll])

  return {
    ingredientSelecting,
    checkIngredientSelected,
    selectIngredient,
    selectAllIngredient,
    isSelectAll,
  }
}

export const useOnSelectIngredient = (
  myIngredients: TIngredient[],
  ingredients: TIngredient[],
  ingredientSelecting: TIngredient[],
) => {
  const [message, setMessage] = useState<string>('')
  const [existNameIngredients, setExistNameIngredients] = useState<string>('')

  const getExistIngredients = useCallback(() => {
    const myIds = myIngredients?.map((e: TIngredient) => e.id) || []
    const exists = ingredientSelecting.filter((e: TIngredient) => myIds.includes(e.id));

    return {
      items: exists,
      ids: exists.map((e: TIngredient) => e.id)
    }
  }, [myIngredients, ingredientSelecting])

  useEffect(() => {
    if (ingredients.length) {
      const { items: existItems } = getExistIngredients()
      const existNames = existItems?.map((e: TIngredient) => e?.name)
      if (existItems?.length) {
        setMessage(_t(`ingredient.msg.msg_8`, {name: existNames.join(', ')}))
        setExistNameIngredients(existNames.join(', '))
      } else {
        setMessage(_t('ingredient.msg.msg_7'))
        setExistNameIngredients('')
      }
    }
  }, [getExistIngredients, setMessage, ingredients])

  return {
    getExistIngredients,
    message,
    existNameIngredients,
  }
}

export default useSelectIngredient
